import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { isPlatform, useIonModal } from '@ionic/react'

import { PaymentModal } from '@/components/organisms/Payment'

import { UserInfo } from '@/services/user'

export const usePaymentModal = ({
  userInfo,
  amount,
  paymentType,
  activityId,
}: {
  userInfo: UserInfo
  amount: number
  paymentType: 'subscription'
  activityId: string
  transactionSuccessfulCallback?: () => void
}) => {
  const { t } = useTranslation('common')
  const isDesktop = isPlatform('desktop')

  const translation = {
    paymentType: t('paymentSubscription.unlockSubscription'),
    withUsername: t('paymentSubscription.withUsername', {
      username: userInfo?.username,
    }),
    price: t('paymentSubscription.labels.price'),
    republikFee: t('paymentSubscription.labels.republikFee'),
    totalPayment: t('paymentSubscription.labels.total'),
    yourWalletBalance: t('paymentSubscription.labels.yourWalletBalance'),
    pay: t('paymentSubscription.actions.pay'),
    info: t('paymentSubscription.info'),
    paymentSuccessful: t('paymentSubscription.paymentSuccessful'),
    paymentUnlockedWith: t('paymentSubscription.paymentUnlockedWith'),
    startToAction: t('paymentSubscription.actions.startToSubscribe'),
    errorSummaryTitle: t('unlockChat.errorSummaryTitle'),
    errorSummaryDetails: t('unlockChat.errorSummaryDetails'),
    close: t('unlockChat.actions.close'),
  }

  const [present, dismiss] = useIonModal(PaymentModal, {
    dismissModal: () => dismiss(),
    userInfo,
    amount,
    translation,
    paymentType,
    activityId,
  })

  const presentPaymentModal = useCallback(
    () =>
      present({
        cssClass: 'payment-modal',
        initialBreakpoint: isDesktop ? undefined : 1,
        breakpoints: isDesktop ? undefined : [0, 1],
      }),
    [isDesktop, present]
  )

  return {
    presentPaymentModal,
    dismissModal: dismiss,
  }
}
